const TAG_IDS = {
  PAGE_NOT_FOUND_404: {
    NOT_FOUND_HOME_LINK: 'not-found-page-home-link',
    NOT_FOUND_HOME_LINK_BUTTON: 'not-found-page-home-link-button',
  },
};

export default TAG_IDS;
